import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { T } from "../../i18n/LocaleType";
import { useBackendContext, useBackendContextMessages } from "../backend/backendContextProvider";
import { useStrokeContext } from "../editor/editorContext";
import { useRouterContext } from "./routerContext";

/** Postará se o připojení k backendu */
export const useBootstrap = () => {

    const {t} = useTranslation();

    const {
        addMessage
    } = useBackendContextMessages();
    const {
        restore
    } = useStrokeContext();

    const {
        connect,
        connected,
        initialised,
        isNewSession,
        session,
    } = useBackendContext();

    const {
        isIncognito,
        mayConnect,
        showMessage,
        showStage,
        showEditor
    } = useRouterContext();

    

    /** Nejprve se pokus připojit k backendu */
    useEffect( () => {

        if ( ! connected && mayConnect ) {
            connect();
        } else if ( isIncognito ) {
            showMessage(T.anonymous_mode_notice);
        }

    }, [mayConnect, connect, connected, initialised, isIncognito, showMessage] );

    /** Po připojení zobraz zprávu podle stavu session! */
    useEffect( () => {

        if ( initialised === true ) {

            if ( isNewSession || session?.state === 0) {

                showEditor();
  
            } else {

                let message = t(T.welcome_back);

                message += "!";

                addMessage( message, true, 5000 );

                if ( session  ) {
                
                    restore( session! );
                
                    showStage();
                
                } else {
                    showMessage( "Chyba připojení" );
                }
    
            }
        }

    }, [initialised, isNewSession, showMessage, addMessage, showEditor,showStage, restore, t] );


    /** Následně se pokud dostat zprávu ze sešny */
    useEffect( () => {

        // Kdykoliv je banlevel větší než 3, zablokuj uživatele permanentně
        if ( session ) {

            if ( session.banlevel >= 3 ) {
                showMessage(
                    t("blocked_notice")
                );
            }
        }

    }, [ session, showMessage, t ] );


    return connected;



}